import "../theme.less";
import "@obsbot/remo-utils/src/polyfill-draggable";
import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";

import { AntdProvider } from "remo-components";
import { useLanguage } from "@obsbot/remo-i18n";
import { AppRoutes } from "../AppRoutes";
import { StoreProvider } from "@obsbot/remo-pages/src/components/StoreProvider";
import { runtime } from "../utils/runtime";
import { RemoServicesContextProvider } from "@obsbot/remo-pages/src/components/RemoServicesContext";
import { setGlobalMessageApi } from "@obsbot/remo-server-api"; // 导入设置全局 messageApi 的函数
import { message } from "antd";
import { eventBus } from "@obsbot/remo-utils";
import { ArgsProps, NoticeType } from "antd/es/message/interface";
import "./index.less";

const App: React.FC = () => {
    const language = useLanguage();

    const [messageApi, contextHolder] = message.useMessage();

    React.useEffect(() => {
        const customMessageApi = {
            ...messageApi,
            success: (
                content: React.ReactNode | ArgsProps,
                duration?: number,
                onClose?: () => void,
            ) => {
                if (
                    typeof content === "object" &&
                    content !== null &&
                    !React.isValidElement(content)
                ) {
                    return messageApi.error({
                        ...content,
                        className: "custom-class",
                    } as ArgsProps);
                }
                return messageApi.success({
                    content: content,
                    duration: duration,
                    onClose: onClose,
                    className: "custom-class",
                });
            },
            warning: (
                content: React.ReactNode | ArgsProps,
                duration?: number,
                onClose?: () => void,
            ) => {
                if (
                    typeof content === "object" &&
                    content !== null &&
                    !React.isValidElement(content)
                ) {
                    return messageApi.error({
                        ...content,
                        className: "custom-class",
                    } as ArgsProps);
                }
                return messageApi.warning({
                    content: content,
                    duration: duration,
                    onClose: onClose,
                    className: "custom-class",
                });
            },
            error: (
                content: React.ReactNode | ArgsProps,
                duration?: number,
                onClose?: () => void,
            ) => {
                if (
                    typeof content === "object" &&
                    content !== null &&
                    !React.isValidElement(content)
                ) {
                    return messageApi.error({
                        ...content,
                        className: "custom-class",
                    } as ArgsProps);
                }
                return messageApi.error({
                    content: content,
                    duration: duration,
                    onClose: onClose,
                    className: "custom-class",
                });
            },
            destroy: () => message.destroy(),
        };
        setGlobalMessageApi(customMessageApi as any); // 在这里设置全局 messageApi
    }, [messageApi]);

    useEffect(() => {
        const handleMessage = ({ message: msg, type }: { message: string; type: string }): void => {
            messageApi.open({
                content: msg,
                type: type as NoticeType,
                className: "custom-class",
                duration: 2,
            });
        };
        eventBus.on("show-message", handleMessage);
        return () => {
            eventBus.off("show-message", handleMessage);
        };
    }, []);

    return (
        <AntdProvider lang={language}>
            {contextHolder}
            <StoreProvider runtime={runtime}>
                <RemoServicesContextProvider>
                    <AppRoutes />
                </RemoServicesContextProvider>
            </StoreProvider>
        </AntdProvider>
    );
};

export const initUI = (): void => {
    ReactDOM.createRoot(document.getElementById("root")!).render(<App />);
};
